export enum DialogTypes {
    PREVIEW = 'preview',
    DUPLICATE = 'duplicate',
    GROUPS_BY_ID = 'groupsById',
    GROUPS = 'groups',
    DELETE = 'delete',
    RESTORE = 'restore',
    IMPLEMENT = 'implement',
    CREATE_GROUP = 'createGroup',
    SUBSCRIBERS = 'subscribers'
}